﻿export class TripChallan {
	public ID!: number;
	public TRIP_ID!: number;
	public CH_NO!: string;
}
